import { Study } from './StudyList';
import { Study as ExtractionStudy } from 'concepts/Extraction/StudyList/StudyTypes';

/**
 * Flatten the reference ids across a list of studies for the LibkeyProvider.
 * The provider dedupes and filters, so callers can pass the raw list.
 */
export const libkeyReferenceIds = (studies: Study[]): number[] =>
  studies.flatMap((study) => (study.references || []).map((ref) => ref.id));

/**
 * As `libkeyReferenceIds`, but for the Extraction study shape, where
 * references are nested under `references.nodes` and ids are strings.
 */
export const extractionLibkeyReferenceIds = (
  studies: ExtractionStudy[]
): string[] =>
  studies.flatMap((study) =>
    (study.references?.nodes || []).map((ref) => ref.id)
  );
